import FrameShell from './FrameShell';

/* A real product screenshot inside the shared browser chrome. */
export default function ShotFrame({ src, alt, caption, maxWidth, domain }) {
  return (
    <FrameShell caption={caption} maxWidth={maxWidth} domain={domain}>
      <img src={src} alt={alt} style={{ display: 'block', width: '100%', height: 'auto' }} />
    </FrameShell>
  );
}
